module.exports = __webpack_public_path__ + "static/media/remedi_logo_whiteV2.0896172e.png";